/** Checks if a lesson node matches a given course node ID */
export const doesLessonNodeMatch = (lessonNode, courseNodeId) => {
  if (!lessonNode || !courseNodeId) return false

  // Check for exact match on course_node_id
  if (lessonNode.course_node_id === courseNodeId) return true

  // Check if leaf_node_id starts with the courseNodeId (handles cases with presentation IDs)
  if (lessonNode.leaf_node_id?.startsWith(courseNodeId)) return true

  // Check for exact match on leaf_node_id
  if (lessonNode.leaf_node_id === courseNodeId) return true

  return false
}

/** Finds a lesson node that matches a given course node ID */
export const findMatchingLessonNode = (lessonNodes, courseNodeId) => {
  if (!Array.isArray(lessonNodes) || !courseNodeId) return null

  return (
    lessonNodes.find(node => doesLessonNodeMatch(node, courseNodeId)) || null
  )
}

/** Extracts the leaf node ID from a lesson node that matches a course node ID */
export const findLeafNodeIdFromLessonNodes = (lessonNodes, courseNodeId) => {
  const match = findMatchingLessonNode(lessonNodes, courseNodeId)
  return match?.leaf_node_id || null
}
